import React, { useEffect, useRef, useState } from "react";

import { Toast } from "primereact/toast";
import defaultLogo from "../../img/defaultLogo.png";
import "./style.scss";
import DataTable from "../../../Common/DataTable";
import moment from "moment";
import {fileDownload} from "../../../../../utils";

const Documents = ({ data, archived, handleItem, deleteHandler }) => {
    const handleRemove = (e, item) => {
        e.stopPropagation();
        deleteHandler(item?._id);
    };

    const handleDownload = (e, item) => {
        e.stopPropagation();
        fileDownload(item?.fullpath, item?.filename);
    };

    return (
        data && (
            <div className="clubs-application">
                <DataTable
                    noCreateBtn
                    emptyMessage="Документы не найдены"
                    search
                    onClick={handleItem}
                    columns={[
                        { field: "name", header: "Название" },
                        { field: "file", header: "Оригинальный файл" },
                        { field: "author", header: "Автор" },
                        { field: "uploaded", header: "Загружен" },
                    ]}
                    rows={data.attachments
                        ?.filter((item) => {
                            if (archived.key === "archived") {
                                return item.archived;
                            } else {
                                return !item.archived;
                            }
                        })
                        .sort((a, b) => {
                            return data.docs?.indexOf(a._id) - data.docs?.indexOf(b._id);
                        })
                        .map((row) => ({
                            ...row,
                            name: { value: row?.publicname },
                            file: { value: row?.filename },
                            author: {
                                value: `${row?.user?.surname ? row?.user?.surname : ""} ${row?.user?.name ? row?.user?.name.slice(0, 1) + "." : ""}${
                                    row?.user?.middlename ? row?.user?.middlename.slice(0, 1) + "." : ""
                                }`,
                            },
                            uploaded: { value: moment(row?.date, "YY-MM-DD").format("DD.MM.YYYY") },
                        }))}
                    paginator={data.length > 8}
                    perPage={8}
                    handleRemove={handleRemove}
                    handleDownload={handleDownload}
                />
            </div>
        )
    );
};

export default Documents;
